import React, { Component } from "react";
import { ToastsStore } from "react-toasts";

class KcNavigation extends Component {
	checkMenuAktif = (menu) => {
		let urlPath = window.location.pathname.split("/");
		let result, menuAktif;
		urlPath[1] === "" ? (menuAktif = "dashboard") : (menuAktif = urlPath[1]);

		menu === menuAktif ? (result = "active") : (result = "");

		return result;
	};

	checkMenuOpen = (menu) => {
		let urlPath = window.location.pathname.split("/");
		let check = menu.includes(urlPath[1]);

		if (check) {
			return "menu-open";
		} else {
			return "";
		}
	};

	checkVerified = (e) => {
		const { list } = this.props.profile;

		if (list && !list.isVerifiedProfile) {
			e.preventDefault();
			ToastsStore.warning("Profile Anda Belum Terverifikasi", 10000);
		}
	};

	render() {
		const { list } = this.props.profile;
		return (
			<aside className="main-sidebar elevation-3">
				<a href="/dashboard" className="brand-link">
					<img src="/img/logo-wo-text.png" alt="Klikcair Logo" className="brand-image" />
					<span className="brand-text font-weight-light">PEMINJAM</span>
				</a>

				<div className="sidebar">
					<nav className="mt-2">
						<ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
							<a href="/#" onClick={(e) => e.preventDefault()} className="nav-header">
								<p> Navigasi </p>
							</a>

							<li className="nav-item">
								<a href="/dashboard" className={`nav-link ${this.checkMenuAktif("dashboard")}`}>
									<i className="nav-icon fas fa-tachometer-alt"></i>
									<p> Beranda </p>
								</a>
							</li>
							{list && !list.isCompleteProfile && (
								<li className="nav-item">
									<a href="/lengkapi-profil" className={`nav-link ${this.checkMenuAktif("lengkapi-profil")}`}>
										<i className="nav-icon fas fa-user-edit"></i>
										<p> Lengkapi Profil </p>
									</a>
								</li>
							)}
							{list && list.isCompleteProfile && (
								<li className="nav-item">
									<a href="/profil" className={`nav-link ${this.checkMenuAktif("profil")}`}>
										<i className="nav-icon fas fa-user-alt"></i>
										<p> Profil </p>
									</a>
								</li>
							)}

							{/*this.checkMenuOpen(["draf-pinjaman", "status-pinjaman", "pengajuan-pinjaman", "pinjaman-aktif", "riwayat-pinjaman"])*/}
							<li className="nav-item menu-open">
								<a href="/#" className="nav-link">
									<i className="nav-icon fas fa-money-check-alt"></i>
									<p>
										Pinjaman <i className="right fa fa-caret-right" />
									</p>
								</a>

								<ul className="nav nav-treeview">
									<li className="nav-item">
										<a href="/draf-pinjaman" onClick={(e) => this.checkVerified(e)} className={`nav-link ${this.checkMenuAktif("draf-pinjaman")}`}>
											<p>Draf Pinjaman</p>
										</a>
									</li>
									<li className="nav-item">
										<a href="/pengajuan-pinjaman" onClick={(e) => this.checkVerified(e)} className={`nav-link ${this.checkMenuAktif("pengajuan-pinjaman")}`}>
											<p>Pengajuan Pinjaman</p>
										</a>
									</li>
									<li className="nav-item">
										<a href="/pinjaman-aktif" onClick={(e) => this.checkVerified(e)} className={`nav-link ${this.checkMenuAktif("pinjaman-aktif")}`}>
											<p>Pinjaman Aktif</p>
										</a>
									</li>
									<li className="nav-item">
										<a href="/riwayat-pinjaman" onClick={(e) => this.checkVerified(e)} className={`nav-link ${this.checkMenuAktif("riwayat-pinjaman")}`}>
											<p>Riwayat Pinjaman</p>
										</a>
									</li>
									{/* 
										<li className="nav-item">
											<a href="/status-pinjaman" className={`nav-link ${this.checkMenuAktif('status-pinjaman')}`}>
												<p>Status Pinjaman</p>
											</a>
										</li> 
									*/}
								</ul>
							</li>

							<li className="nav-item">
								<a href="/riwayat-transaksi" onClick={(e) => this.checkVerified(e)} className={`nav-link ${this.checkMenuAktif("riwayat-transaksi")}`}>
									<i className="nav-icon fas fa-history"></i>
									<p> Riwayat Transaksi </p>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</aside>
		);
	}
}

export default KcNavigation;
